import React, {useContext, useEffect, useState} from 'react';
import '../../styles/Login.css';
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import RecapPDF from "../../components/RecapPDF";
import { useLocation, useParams } from "react-router";
import Loading from "../../components/Loading/Loading";
import Header from "../../components/Header";
import "../../styles/Home.css"
import ReturnButton from "../../components/BoutonRetour/ReturnButton";
import Requetes from "../../services/Requetes";
import BreadContext from "../../context/BreadContext";
import BreadcrumbsItem from "../../components/BreadcrumbsItem";

const RecapViewerPage = () => {
    const location = useLocation();
    const { id } = useParams();
    const [pvi, setPvi] = useState("");
    const [loading, setLoading] = useState(true);
    const fetchPVI = async () => {
        let data = await Requetes.getPvi(id);
        setPvi(data.data);
        setLoading(false);
    }
    const route = {
        name: "Récapitulatif PDF",
        path: location.pathname,
        state: {pviEBP:location.state.pviEBP}
    }


    const nameOfFile = (pviEpb) => {
        let string = "";
        string = string + pviEpb.Client.replaceAll(" ", "");
        if (pviEpb.LieuIntervention !== '   '){
            string = string + "_" + pviEpb.LieuIntervention.replaceAll(" ", "");
        }
        string = string + "_" + pviEpb.NumDossier;
        string = string + ".pdf";
        return string;
    }

    useEffect(() => {
        fetchPVI().then(r => '');
    }, [id])

    return (<>
        <Header />
             <BreadcrumbsItem route={route}/>
        <div className='containerHome'>
                {loading && <Loading />}
                {!loading && <>
                    {/*<ReturnButton title={"PDF de l'intervention N°" + id} states={{ pviEBP: location.state.pviEBP }} text={""} link={"/recap/" + id} />*/}
                    <div>
                        <PDFDownloadLink document={<RecapPDF pvi={pvi} id={id} pviEBP={location.state.pviEBP}/>} fileName={nameOfFile(location.state.pviEBP)}>
                            {({ blob, url, loadingPDF, error }) =>
                                loadingPDF ? 'Loading document...' : 'Telecharger!'
                            }
                        </PDFDownloadLink>
                    </div>
                    <PDFViewer width={'80%'} height={'800rem'} fileName={nameOfFile(location.state.pviEBP)} >
                        <RecapPDF pvi={pvi} id={id} pviEBP={location.state.pviEBP} />
                    </PDFViewer>
                </>}

            </div>
    </>
        
    );
};

export default RecapViewerPage;